import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { BRAND } from "@/data/content";
import { useConsultation } from "@/components/site/consultation";

const links = [
  { label: "Advantage", href: "#advantage" },
  { label: "Work", href: "#work" },
  { label: "Packages", href: "#packages" },
  { label: "Why Us", href: "#why" },
  { label: "Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
];

export default function Nav() {
  const { open } = useConsultation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-navy/90 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 lg:px-10">
        <a href="#top" className="flex flex-col leading-none" data-testid="nav-logo">
          <span className="font-serif text-2xl tracking-tight text-white">First<span className="text-gold"> Impression</span></span>
          <span className="mt-0.5 text-[9px] uppercase tracking-[0.35em] text-white/50">Property Management</span>
        </a>

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="group relative text-xs uppercase tracking-[0.15em] text-white/70 transition-colors hover:text-white"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a href={BRAND.phoneHref} className="hidden items-center gap-2 text-xs text-white/70 hover:text-gold transition-colors lg:flex" data-testid="nav-phone">
            <Phone className="h-3.5 w-3.5" /> {BRAND.phone}
          </a>
          <button
            onClick={() => open()}
            data-testid="nav-cta-button"
            className="bg-gold px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] text-navy transition-[transform,filter] duration-300 hover:-translate-y-0.5 hover:brightness-105"
          >
            Free Consultation
          </button>
        </div>
      </div>
    </motion.header>
  );
}
